/** One browser-session signal; programmatic scroll/load/idle never counts. */
let engaged = false;
const subscribers = new Set<() => void>();
const events = ["wheel", "pointerdown", "touchstart", "keydown", "click"] as const;

export function isEngagementEvent(event: Pick<Event, "type" | "isTrusted">) {
  return event.isTrusted && events.some((type) => type === event.type);
}

function onInteraction(event: Event) {
  if (!isEngagementEvent(event) || engaged) return;
  engaged = true;
  events.forEach((type) => window.removeEventListener(type, onInteraction));
  subscribers.forEach((notify) => notify());
}

export function subscribeEngagement(notify: () => void) {
  subscribers.add(notify);
  if (!engaged && subscribers.size === 1) {
    events.forEach((type) => window.addEventListener(type, onInteraction, { passive: true }));
  }
  return () => {
    subscribers.delete(notify);
    if (!subscribers.size) events.forEach((type) => window.removeEventListener(type, onInteraction));
  };
}

export const getEngagementSnapshot = () => engaged;
export const getServerEngagementSnapshot = () => false;

export function canMountDeferredContent(engagement: boolean, visible: boolean) {
  return engagement && visible;
}